import { TimeRangeGranularity, TimeRangePeriod } from '@/api/affiliate/serv/oec_affiliate_creator_marketplace_api';
var getBefore17HoursUnixTs = function getBefore17HoursUnixTs() {
  var SEVENTEEN_HOURS = 17 * 3600;
  var isProdEnv = isProd && isOnline;
  var startTimestamp = Date.now() / 1000 - SEVENTEEN_HOURS;
  var stsParam = new URLSearchParams(window.location.search).get('sts');
  if (!isProdEnv && stsParam) {
    return stsParam;
  }
  return Math.floor(startTimestamp).toString();
};
export var createAffiliateCreatorProfileReqParams = function createAffiliateCreatorProfileReqParams(creatorId, timeRangePeriod, timeRangeGranularity, aggregationTypes) {
  var _aggregationTypes$map;
  return {
    common_params: {
      time_selectors: [{
        period: timeRangePeriod,
        granularity: timeRangeGranularity,
        start_timestamp: getBefore17HoursUnixTs()
      }]
    },
    filters: (_aggregationTypes$map = aggregationTypes === null || aggregationTypes === void 0 ? void 0 : aggregationTypes.map(function (type) {
      return {
        creator_oec_id: creatorId,
        type: type
      };
    })) !== null && _aggregationTypes$map !== void 0 ? _aggregationTypes$map : [{
      creator_oec_id: creatorId
    }]
  };
};
export var getProfileDataRequestParams = function getProfileDataRequestParams(creatorId) {
  return createAffiliateCreatorProfileReqParams(creatorId, TimeRangePeriod.PAST_28_DAYS, TimeRangeGranularity.DAYS_28);
};